<div
	[class.border-2]="border()"
	[class.rounded-full]="border()"
	[ngStyle]="{
		borderColor: border() ? badgeColors.color : 'transparent',
	}"
	class="flex space-x-2"
>
	<div
		[style.background-color]="badgeColors.lighten"
		[style.color]="textColor ? textColor : badgeColors.color"
		class="flex items-center gap-1 space-x-1 rounded-full px-2 text-xs w-full"
		style="padding-top: 0.2em; padding-bottom: 0.2rem"
	>
		<!-- DOT (optional) -->
		@if (enableDot()) {
			<div
				style="width: 0.4rem; height: 0.4rem"
				class="rounded-full"
				[style.background-color]="badgeColors.color"
			></div>
		}
		<!-- TEXT -->
		<div
			class="flex-1 text-center"
			[class.font-bold]="bold()"
		>
			{{ text() | translate }}
		</div>
	</div>
</div>
